<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>小程序封面图设置</h3>
                </el-col>
            </el-row>
            <el-form>
                <el-form-item label="封面图：" label-width="100px">
                    <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :show-file-list="false" :on-success="handleAvatarSuccess" :on-error="handleError" :before-upload="beforeAvatarUpload" :data="uptoken">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label-width="100px">
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    
    </div>
</template>

<script>
    import {
        getGlobalSettings,
        patchGlobalSettings
    } from '../../api/version'
    
    export default {
        data() {
            return {
                pic: '',
                imageUrl: '',
                uptoken: {
                    token: sessionStorage.token
                },
            }
        },
    
        created() {
            getGlobalSettings().then(res => {
                console.log(res.data)
                res.data.forEach(item => {
                    if (item.SettingKey === 'share_pic') {
                        this.imageUrl = 'https://img.shareplay.cc/' + item.SettingValue
                        this.pic = item.SettingValue
                    }
                })
            })
    
        },
    
        methods: {
            onSubmit() {
                let data = {
                    SettingKey: 'share_pic',
                    SettingValue: this.pic
                }
                patchGlobalSettings(sessionStorage.userId, data).then(res => {
                    console.log(res)
                    if (res.data) {
                        this.$message({
                            message: '更改成功',
                            type: 'success'
                        });
                    }
                }, err => {
                    this.$message.error('更改失败')
                })
            },
            handleAvatarSuccess(res, file) {
                this.pic = res.key
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                this.uptoken = {
                    token: sessionStorage.token
                }
    
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            handleError() {
                this.$message.error('请重新登录')
                this.$router.push('/login')
            },
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// WechatPic.vue?2ff185aa